export default "__VITE_ASSET__CFAygNC0__"